import React, { useEffect } from 'react';
import {
  CONTINUE,
  SUBSCRIBE_CONFIRMATION,
  DEALS_SUBSCRIPTION,
} from '../../../config/text/text';
import { trackEvent } from '../../../helpers/analytics';
import WowModal from '../../WowModal';
import ButtonForm from '../button/CTAButton';

const ConfirmationModal = ({
  currentRef,
  showConfirmationModal,
  setShowConfirmationModal,
  subscribe,
}) => {
  useEffect(() => {
    trackEvent('google_one_deals_subscription_popup_displayed');
  }, []);

  return (
    <>
      <WowModal
        ariaLabelledBy="id-subscribe"
        centered
        container={currentRef}
        extraClasses="with-header-background with-animation fullscreen-mobile"
        setShowModal={setShowConfirmationModal}
        showModal={showConfirmationModal}
        size="lg"
        title={DEALS_SUBSCRIPTION}
      >
        <div className="confirmation-text-wrapper">
          <span
            className="confirmation-text"
            dangerouslySetInnerHTML={{ __html: SUBSCRIBE_CONFIRMATION }}
          />
        </div>
        <div className="confirmation-button">
          <ButtonForm
            className="with-header-background no-3d"
            onClick={subscribe}
          >
            {CONTINUE.toUpperCase()}
          </ButtonForm>
        </div>
      </WowModal>
      <style jsx>{`
        .confirmation-text {
          margin-bottom: 20px;
          display: inline-block;
        }
        .confirmation-button {
          border-top: 1px solid #ccc;
          padding: 12px;
          min-height: 60px;
          text-align: right;
        }
        .confirmation-text-wrapper {
          padding: 12px;
          display: block;
        }
      `}</style>
    </>
  );
};

export default ConfirmationModal;
